import {BaseStore, globalStore} from "../../stem-core/state/Store";
import {SubscriptionOffer} from "./SubscriptionOfferStore";
import {field} from "../../stem-core/state/StoreField";
import {apiClient} from "../connection/BlinkApiClient";
import {BaseEnum, makeEnum} from "../../stem-core/state/BaseEnum";
import {Merchant} from "./MerchantStore";
import {StemDate} from "../../stem-core/time/Date";

@makeEnum
export class CoverageChangeType extends BaseEnum {
    static UPGRADE;
    static DOWNGRADE;
    static EQUIVALENT;
    static OTHER;

    // For downgrades there's no reason to apply the conversion now, since you're not getting any money back
    canAllowInstantConversion(): boolean {
        return this === CoverageChangeType.UPGRADE || this === CoverageChangeType.OTHER;
    }
}


@globalStore
export class SubscriptionCoverage extends BaseStore("subscriptionCoverage") {
    @field("Merchant") merchant: Merchant;
    @field(String) name: string;
    @field(Date) deletedAt: StemDate;
    @field(Object) description: object[]; // An array of description items
    @field(Boolean) requiresAddress: boolean;
    @field(Boolean) addressRequiresPostalCode: boolean;
    @field(Boolean) addressRequiresPhoneNumber: boolean;
    @field(Boolean) billableProRata: boolean;
    @field(String) blinkCoverage: string;
    @field(String) extraCoverage: string;
    @field("SubscriptionCoverage") includesCoverage: SubscriptionCoverage;
    @field(Array) benefitIds: number[];

    getName(): string {
        return this.name;
    }

    getDescription(): any[] {
        return this.description;
    }

    getAvailableOffers(): SubscriptionOffer[] {
        return SubscriptionOffer.filter(offer => offer.coverageId === this.id && offer.isAvailable());
    }

    // TODO @branch rename to isActive?
    isAvailable(): boolean {
        return !this.deletedAt && this.getAvailableOffers().length > 0;
    }

    toString(): string {
        return this.getName();
    }
}

export async function apiMerchantCreateSubscriptionCoverage(request: any): Promise<SubscriptionCoverage> {
    const response = await apiClient.post("/merchant/create_subscription_coverage", request);
    return SubscriptionCoverage.loadObject(response);
}

export async function apiMerchantEditSubscriptionCoverage(request: any): Promise<any> {
    return apiClient.post("/merchant/edit_subscription_coverage", request, {allowNulls: true});
}
